import { render, staticRenderFns } from "./r-item-kind-dropdown.vue?vue&type=template&id=4c689832"
import script from "./r-item-kind-dropdown.vue?vue&type=script&lang=js"
export * from "./r-item-kind-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c689832')) {
      api.createRecord('4c689832', component.options)
    } else {
      api.reload('4c689832', component.options)
    }
    module.hot.accept("./r-item-kind-dropdown.vue?vue&type=template&id=4c689832", function () {
      api.rerender('4c689832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-kind/r-item-kind-dropdown.vue"
export default component.exports